import { gql, useQuery } from '@apollo/client';
import { getGuid, getLoggedInStatus } from 'Utils/auth';
import { useState, useEffect } from 'react';

export const GET_CART = gql`
  query getCart($loggedInStatus: LoggedInStatus!, $guid: String!) {
    cart(loggedInStatus: $loggedInStatus, guid: $guid) {
      products {
        product {
          id
        }
        quantityInCart
      }
    }
  }
`;

const useGetCart = () => {
  const [shouldskipQuery, setShouldskipQuery] = useState(false);
  const {
    data,
    loading: isCartBagCountLoading,
    error: cartBagCountError,
  } = useQuery(GET_CART, {
    variables: {
      loggedInStatus: getLoggedInStatus(),
      guid: getGuid(),
    },
    skip: shouldskipQuery,
  });

  useEffect(() => {
    // check whether data exists
    if (!isCartBagCountLoading && !!data) {
      setShouldskipQuery(true);
    }
  }, [data, isCartBagCountLoading]);
  return { cartDetails: data, isCartBagCountLoading, cartBagCountError };
};

export default useGetCart;
